// src/audio/audioManager.js
import { Howl } from "howler";

const audioManager = {
  sounds: {}, // Объект для хранения звуков

  /**
   * Добавляет звук в менеджер.
   * @param {string} name - Имя звука.
   * @param {string|string[]} src - Путь к аудиофайлу или массив путей.
   * @param {Object} options - Опции для Howl.
   */
  addSound(name, src, options = {}) {
    this.sounds[name] = new Howl({
      src: Array.isArray(src) ? src : [src],
      loop: options.loop || false,
      volume: options.volume || 1,
      ...options,
    });
  },

  /**
   * Воспроизводит звук.
   * @param {string} name - Имя звука.
   */
  play(name) {
    if (this.sounds[name]) {
      this.sounds[name].play();
    } else {
      console.warn(`Sound "${name}" not found.`);
    }
  },

  /**
   * Останавливает звук.
   * @param {string} name - Имя звука.
   */
  stop(name) {
    if (this.sounds[name]) {
      this.sounds[name].stop();
    } else {
      console.warn(`Sound "${name}" not found.`);
    }
  },

  /**
   * Останавливает все звуки.
   */
  stopAll() {
    Object.values(this.sounds).forEach((sound) => sound.stop());
  },

  /**
   * Устанавливает громкость звука.
   * @param {string} name - Имя звука.
   * @param {number} volume - Громкость (от 0 до 1).
   */
  setVolume(name, volume) {
    if (this.sounds[name]) {
      this.sounds[name].volume(volume);
    } else {
      console.warn(`Sound "${name}" not found.`);
    }
  },

  /**
   * Устанавливает скорость воспроизведения звука.
   * @param {string} name - Имя звука.
   * @param {number} rate - Скорость воспроизведения (например, 1.0 - нормальная скорость, 0.5 - медленнее, 2.0 - быстрее).
   */
  setRate(name, rate) {
    if (this.sounds[name]) {
      this.sounds[name].rate(rate);
    } else {
      console.warn(`Sound "${name}" not found.`);
    }
  },

  /**
   * Проверяет, играет ли звук.
   * @param {string} name - Имя звука.
   * @returns {boolean} - true, если звук играет.
   */
  isPlaying(name) {
    if (this.sounds[name]) {
      return this.sounds[name].playing();
    } else {
      console.warn(`Sound "${name}" not found.`);
      return false;
    }
  },
};

export default audioManager;
